export default __webpack_public_path__ + "static/kafe-presentation-726940438e28abbe3e5c9959db8bb190.png";